export const config = {
    apiUrl: process.env.VUE_APP_API_URL,
    imagesApi: process.env.VUE_APP_IMAGES_API,
    chartsUrl: process.env.VUE_APP_CHARTS_BASE_URL,
    clientUrl: process.env.VUE_APP_WEBPAGE_URL
}
